export default __webpack_public_path__ + "static/media/mavis2000w.79f46846.webp";